import {
  INITIALISE_PICTURE,
  SET_PICTURE_HIGH_QUALITY_LOADING,
  SET_PICTURE_HIGH_QUALITY_LOADED,
  SET_PICTURE_LOW_QUALITY_LOADING,
  SET_PICTURE_LOW_QUALITY_LOADED,
  SET_PICTURE_BASE_QUALITY_ERROR,
  SET_LOW_QUALITY_RETRIES,
  SET_STOP_LOW_QUALITY_RETRIES,
  RESET_LOW_QUALITY_RETRIES,
  SET_HIGH_QUALITY_RETRIES,
  SET_STOP_HIGH_QUALITY_RETRIES,
  SET_ONLINE_STATUS,
  RESET_HIGH_QUALITY_RETRIES,
} from './actions';

const TIMEOUTS = {
  0: 0,
  1: 1000,
  2: 3000,
  3: 5000,
  4: 10000,
  5: 20000,
  6: 30000,
};

const initialisePicture = (state, action) => ({
  ...state,
  [action.id]: {
    highQualityLoaded: false,
    highQualityLoading: false,
    lowQualityLoaded: false,
    lowQualityLoading: false,
    baseQualityError: false,
    lowQualityRetries: 0,
    highQualityRetries: 0,
    timeouts: TIMEOUTS,
  },
});

const setHighQualityLoading = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    highQualityLoading: action.isLoading,
  },
});

const setHighQualityLoaded = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    highQualityLoaded: true,
  },
});

const setLowQualityLoading = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    lowQualityLoading: action.isLoading,
  },
});

const setLowQualityLoaded = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    lowQualityLoaded: true,
  },
});

const setBaseQualityError = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    baseQualityError: true,
  },
});

const setLowQualityRetries = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    lowQualityRetries: action.lowQualityRetries,
  },
});

const setStopLowQualityRetries = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    stopLowQualityRetries: action.stopLowQualityRetries,
  },
});

const resetLowQualityRetries = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    lowQualityRetries: 0,
    stopLowQualityRetries: false,
    lowQualityLoading: false,
  },
});

const setHighQualityRetries = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    highQualityRetries: action.highQualityRetries,
  },
});

const setStopHighQualityRetries = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    stopHighQualityRetries: action.stopHighQualityRetries,
  },
});

const resetHighQualityRetries = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    highQualityRetries: 0,
    stopHighQualityRetries: false,
    highQualityLoading: false,
  },
});

const setOnlineStatus = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    online: action.online,
  },
});

const reducer = {
  [INITIALISE_PICTURE]: initialisePicture,
  [SET_PICTURE_HIGH_QUALITY_LOADING]: setHighQualityLoading,
  [SET_PICTURE_HIGH_QUALITY_LOADED]: setHighQualityLoaded,
  [SET_PICTURE_LOW_QUALITY_LOADING]: setLowQualityLoading,
  [SET_PICTURE_LOW_QUALITY_LOADED]: setLowQualityLoaded,
  [SET_PICTURE_BASE_QUALITY_ERROR]: setBaseQualityError,
  [SET_LOW_QUALITY_RETRIES]: setLowQualityRetries,
  [SET_STOP_LOW_QUALITY_RETRIES]: setStopLowQualityRetries,
  [RESET_LOW_QUALITY_RETRIES]: resetLowQualityRetries,
  [SET_HIGH_QUALITY_RETRIES]: setHighQualityRetries,
  [SET_STOP_HIGH_QUALITY_RETRIES]: setStopHighQualityRetries,
  [SET_ONLINE_STATUS]: setOnlineStatus,
  [RESET_HIGH_QUALITY_RETRIES]: resetHighQualityRetries,
};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
